import { Component } from '@angular/core';
import { CampaignService } from '../../services/campaign.service';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
})
export class NotesComponent {
  constructor(public campaignService: CampaignService) {}
}
